module.exports = __webpack_public_path__ + "images/team/dan-ivanovic@2x.jpg";